import { ComponentType, HtmlHTMLAttributes, memo, useCallback } from "react";
import classNames from "classnames";
import pluralize from "pluralize";
import ReactPaginate from "react-paginate";
import { SimpleSelect } from "../../../../form/fields";

import { ReactComponent as SimpleArrow } from "./icons/simple-arrow.svg";

import styles from "./style.module.scss";

export type PagerProps = {
  pageCount: number,
  pageIndex: number,
  pageSize: number,
  pageOptions?: number[],
  gotoPage: (updater: ((pageIndex: number) => number) | number) => void;
  setPageSize: (pageSize: number) => void,
  hidden: boolean,
} & HtmlHTMLAttributes<HTMLDivElement>

const Pager = memo<PagerProps>((
  {
    pageCount,
    pageIndex,
    pageSize,
    pageOptions,
    gotoPage,
    setPageSize,
    className,
    hidden,
    ...props
  }) => {

  const onPageChange = useCallback(
    ({ selected }: { selected: number }) => gotoPage(selected),
    [ gotoPage ],
  );

  const setOptionLabel = useCallback((option: number) => `${option} ${pluralize("line", option)}`, []);

  return (
    <div className={classNames(styles.root, className)} {...props}>
      {
        !hidden && <>
          <ReactPaginate
            previousLabel={<SimpleArrow data-test="prev" />}
            nextLabel={<SimpleArrow style={{ transform: "rotateZ(180deg)" }} data-test="next" />}
            forcePage={pageIndex}
            breakLabel="..."
            pageCount={pageCount || 1}
            marginPagesDisplayed={1}
            pageRangeDisplayed={4}
            onPageChange={onPageChange}

            containerClassName={styles.container}
            pageClassName={styles.page}
            activeClassName={styles.active}
            previousClassName={styles.prevNext}
            nextClassName={styles.prevNext}
            breakClassName={styles.dots}
            disabledClassName={styles.disabled}
          />
          <SimpleSelect
            options={pageOptions}
            className={styles.linesSelect}
            value={pageSize}
            onChange={setPageSize as any}
            setOptionLabel={setOptionLabel}
          />
        </>
      }
    </div>
  );
});

(Pager as ComponentType<PagerProps>).defaultProps = {
  pageOptions: [ 10, 20, 30, 40, 50, 100 ],
};

export default Pager;
